import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {ApiResponse} from '../../api/api-response';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartnerGoogleAdsService {
  private routePath = '/partner/google-ads';

  constructor(
    protected apiClient: ApiClientService,
  ) {
  }

  getAccountInfos(partnerId: number): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + partnerId + '/account-infos', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getConversionActionsStatus(partnerId: number): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.get(this.routePath + '/' + partnerId + '/conversion-action', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData().actions);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  createConversionActionsStatus(partnerId: number): Observable<void> {
    return new Observable<void>((subscriber) => {
      this.apiClient.post(this.routePath + '/' + partnerId + '/conversion-action/create', {}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next();
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
